import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
    mostraAlertaError,
    mostraAlertaOk,
} from "../../../componentes/alerts/sweetAlert";
import { AxiosPublico } from "../../../componentes/axios/Axios";
import Card from "../../../componentes/contenedores/Card";
import GestionUbicacion from "../../../componentes/googlemap/GestionUbicacion";
import VerUbicacion from "../../../componentes/googlemap/VerUbicacion";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import Page from "../../../componentes/plantilla/Page";
import {
    CotizacionesGuardar,
} from "../../../configuracion/apiUrls";
import { DireccionConfig } from "../../../configuracion/Empresa";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import ModalProductosWizard from "./nuevo/ModalProducto";
import { formatoMoneda } from "../../../configuracion/validaciones";
import ModalDescuentoCotizacion from "./descuento/ModalDescuento";
import { ImprimirCotizacion } from "./imprimir/ImprimirCotizacion";

const calcularPrecioFinalConTodo = (datosProducto, cantidad, selectedLote = null) => {
    let precioFinal;
    let esMayoreoAplicado = false;

    if (selectedLote && selectedLote.precio) {
        precioFinal = parseFloat(selectedLote.precio);
    } else {
        precioFinal = parseFloat(datosProducto.precio) || 0;
    }

    let precioOriginalProducto = precioFinal;

    if (selectedLote && selectedLote.loteprecios && selectedLote.loteprecios.length > 0) {
        const nivelesMayoreoOrdenadosLote = [...selectedLote.loteprecios].sort((a, b) => b.cantidad - a.cantidad);
        for (const nivel of nivelesMayoreoOrdenadosLote) {
            if (cantidad >= nivel.cantidad) {
                precioFinal = parseFloat(nivel.precio) || 0;
                esMayoreoAplicado = true;
                break;
            }
        }
    }
    else if (!selectedLote && datosProducto.productoprecios && datosProducto.productoprecios.length > 0) {
        const nivelesMayoreoOrdenados = [...datosProducto.productoprecios].sort((a, b) => b.cantidad - a.cantidad);
        for (const nivel of nivelesMayoreoOrdenados) {
            if (cantidad >= nivel.cantidad) {
                precioFinal = parseFloat(nivel.precio) || 0;
                esMayoreoAplicado = true;
                break;
            }
        }
    }

    return {
        price: precioFinal.toFixed(2),
        precioOriginalProducto: precioOriginalProducto.toFixed(2),
        esMayoreoAplicado,
    };
};


const HomeCotizaciones = () => {
    const { carritoCotizacion, vaciarCarritoCotizacion, setCarritoCotizacion, usuario, estacion } = useContextUsuario();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const { listaProductos = [], listaClientes } = useContextEmpleado();
    const fechaActual = moment().format("dddd, DD [de] MMMM [de]YYYY");
    const [notaGeneral, setNotaGeneral] = useState("");
    const [requiereEnvio, setRequiereEnvio] = useState(false);
    const [mostrarBotonEnvio, setMostrarBotonEnvio] = useState(false);
    const [nuevaDireccion, setNuevaDireccion] = useState({
        direccion: DireccionConfig.direccion,
        longitud: DireccionConfig.longitud,
        latitud: DireccionConfig.latitud,
    });
    const [seleccionarDireccion, setSeleccionarDireccion] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formularioClientes, setFormularioClientes] = useState({
        direcciones: [],
    });
    const [selectedEvent, setSelectedEvent] = useState({});
    const [modalClienteOpen, setModalClienteOpen] = useState(false);
    const clientes = listaClientes || [];
    const [clienteSearchTerm, setClienteSearchTerm] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);
    const [isDescuentoModalOpen, setIsDescuentoModalOpen] = useState(false);

    const datos = {
        titulo: {
            titulo: "Nueva cotización",
            url: "/app/clientes/cotizaciones/nuevo",
            tituloUrl: "cotizaciones",
            nombreUrl: "Inicio Cotizaciones",
        },
    };

    useEffect(() => {
        if (seleccionarDireccion) {
            setIsModalOpen(false);
            if (formularioClientes.direcciones.length >= 1) {
                mostraAlertaError("Solo puedes agregar una dirección por cotización.");
            } else {
                setFormularioClientes((prevState) => ({
                    ...prevState,
                    direcciones: [...prevState.direcciones, nuevaDireccion],
                }));
            }
            setSeleccionarDireccion(false);
        }
    }, [seleccionarDireccion, nuevaDireccion, formularioClientes.direcciones]);

    const eliminarDireccion = (index) => {
        setFormularioClientes((prevState) => {
            const nuevasDirecciones = [...prevState.direcciones];
            nuevasDirecciones.splice(index, 1);
            return { ...prevState, direcciones: nuevasDirecciones };
        });
    };

    const agregarAlCarrito = (productoSeleccionado) => {
        setCarritoCotizacion((prev) => {
            const productoExistente = prev.find((item) => item.id === productoSeleccionado.id &&
                item.loteSeleccionado?.id === productoSeleccionado.loteSeleccionado?.id &&
                item.loteInventarioSeleccionado?.id === productoSeleccionado.loteInventarioSeleccionado?.id
            );

            if (productoExistente) {
                const nuevaCantidad = productoExistente.cantidad + productoSeleccionado.cantidad;
                const productoCompleto = listaProductos.find(p => p.id === productoSeleccionado.id);
                const detallesPrecio = calcularPrecioFinalConTodo(
                    productoCompleto,
                    nuevaCantidad,
                    productoSeleccionado.loteSeleccionado
                );
                return prev.map((item) =>
                    (item.id === productoSeleccionado.id &&
                        item.loteSeleccionado?.id === productoSeleccionado.loteSeleccionado?.id &&
                        item.loteInventarioSeleccionado?.id === productoSeleccionado.loteInventarioSeleccionado?.id)
                        ? { ...item, cantidad: nuevaCantidad, ...detallesPrecio }
                        : item
                );
            } else {
                return [...prev, { ...productoSeleccionado }];
            }
        });
    };

    const recalcularPrecio = (id, nuevaCantidad, loteSeleccionado) => {
        const productoCompleto = listaProductos.find(p => p.id === id);
        if (!productoCompleto) return {};
        return calcularPrecioFinalConTodo(productoCompleto, nuevaCantidad, loteSeleccionado);
    };

    const incrementarCantidad = (id, loteSeleccionado = null, loteInventarioSeleccionado = null) => {
        setCarritoCotizacion((prev) =>
            prev.map((item) => {
                if (item.id === id &&
                    item.loteSeleccionado?.id === loteSeleccionado?.id &&
                    item.loteInventarioSeleccionado?.id === loteInventarioSeleccionado?.id) {
                    const nuevaCantidad = item.cantidad + 1;
                    if (item.precioAjustadoOriginal) {
                        return { ...item, cantidad: nuevaCantidad };
                    }
                    const detallesPrecio = recalcularPrecio(id, nuevaCantidad, loteSeleccionado);
                    return { ...item, cantidad: nuevaCantidad, ...detallesPrecio };
                }
                return item;
            })
        );
    };

    const decrementarCantidad = (id, loteSeleccionado = null, loteInventarioSeleccionado = null) => {
        setCarritoCotizacion((prev) =>
            prev.map((item) => {
                if (item.id === id &&
                    item.loteSeleccionado?.id === loteSeleccionado?.id &&
                    item.loteInventarioSeleccionado?.id === loteInventarioSeleccionado?.id &&
                    item.cantidad > 1) {
                    const nuevaCantidad = item.cantidad - 1;
                    if (item.precioAjustadoOriginal) {
                        return { ...item, cantidad: nuevaCantidad };
                    }
                    const detallesPrecio = recalcularPrecio(id, nuevaCantidad, loteSeleccionado);
                    return { ...item, cantidad: nuevaCantidad, ...detallesPrecio };
                }
                return item;
            })
        );
    };

    const actualizarCantidad = (id, valor, loteSeleccionado = null, loteInventarioSeleccionado = null) => {
        setCarritoCotizacion((prev) =>
            prev.map((p) => {
                if (p.id === id &&
                    p.loteSeleccionado?.id === loteSeleccionado?.id &&
                    p.loteInventarioSeleccionado?.id === loteInventarioSeleccionado?.id) {
                    const nuevaCantidad = parseInt(valor, 10) || 1;
                    if (p.precioAjustadoOriginal) {
                        return { ...p, cantidad: nuevaCantidad };
                    }
                    const detallesPrecio = recalcularPrecio(id, nuevaCantidad, loteSeleccionado);
                    return { ...p, cantidad: nuevaCantidad, ...detallesPrecio };
                }
                return p;
            })
        );
    };

    const handleOpenDescuentoModal = (item) => {
        setSelectedItem(item);
        setIsDescuentoModalOpen(true);
    };

    const handleAplicarDescuento = (nuevoItem) => {
        setCarritoCotizacion((prev) =>
            prev.map((item) => {
                if (item.id === nuevoItem.id &&
                    item.loteSeleccionado?.id === nuevoItem.loteSeleccionado?.id &&
                    item.loteInventarioSeleccionado?.id === nuevoItem.loteInventarioSeleccionado?.id) {
                    return nuevoItem;
                }
                return item;
            })
        );
        setSelectedItem(null);
        setIsDescuentoModalOpen(false);
    };

    const totalCotizacion = useMemo(() => {
        return carritoCotizacion.reduce((total, item) => {
            return total + (parseFloat(item.price) * item.cantidad);
        }, 0);
    }, [carritoCotizacion]);

    const limpiarDatos = () => {
        setFormularioClientes({
            direcciones: [],
        });
        setNotaGeneral("");
        vaciarCarritoCotizacion();
        setRequiereEnvio(false);
        setMostrarBotonEnvio(false);
        setSelectedEvent({});
        setNuevaDireccion({
            direccion: DireccionConfig.direccion,
            longitud: DireccionConfig.longitud,
            latitud: DireccionConfig.latitud,
        });
    };

    const handleClienteSeleccionado = (cliente) => {
        setSelectedEvent((prev) => ({
            ...prev,
            clienteId: cliente.id,
            clienteNombre: cliente.nombreCompleto,
        }));
        setModalClienteOpen(false);
    };


    const guardarCotizacion = async () => {
        if (carritoCotizacion.length === 0) {
            mostraAlertaError("No hay productos en el carrito.", "Error");
            return;
        }
        if (!selectedEvent.clienteId) {
            mostraAlertaError(
                "Debes seleccionar un cliente antes de guardar el pedido.",
                "Error"
            );
            return;
        }

        if (!usuario?.datoPersonales?.id) {
            mostraAlertaError(
                "No se pudo identificar al empleado. Verifica tu sesión.",
                "Error"
            );
            return;
        }
        const direccionesParaGuardar = formularioClientes.direcciones.filter(
            (f) => f.direccion && f.longitud !== null && f.latitud !== null
        );

        const detalles = carritoCotizacion.map((item) => ({
            productoId: item.id,
            cantidad: item.cantidad || 1,
            precio: parseFloat(item.price) || 0,
            loteId: item.loteSeleccionado?.id || null,
            loteInventarioId: item.loteInventarioSeleccionado?.id || null,
        }));

        const payload = {
            ...formularioClientes,
            fecha: moment().toISOString(),
            estado: "Pendiente",
            envio: direccionesParaGuardar.length > 0 ? "Pendiente" : "Sin envío",
            notas: notaGeneral || "Sin notas",
            clienteId: selectedEvent.clienteId,
            empleadoId: usuario.datoPersonales.id,
            detalles,
            direcciones: direccionesParaGuardar,
            total: parseFloat(totalCotizacion),
            estacionDatos: estacion
        };

        try {
            const response = await AxiosPublico.post(CotizacionesGuardar, payload);
            mostraAlertaOk("Cotización guardada correctamente.", "Éxito");
            ImprimirCotizacion(response.data);
            limpiarDatos();
        } catch (error) {
            mostraAlertaError("Error al guardar la cotización.", "Error");
        }
    };


    const filteredClientes = clientes.filter((cliente) => {
        const searchTerm = clienteSearchTerm.trim().toLowerCase();

        // 1. Búsqueda por Nombre Completo del Cliente
        const nombreClienteMatch = cliente.nombreCompleto
            .toLowerCase()
            .includes(searchTerm);

        // 2. Búsqueda por Nombre de la Empresa del Cliente
        const nombreEmpresaMatch =
            cliente.ClienteEmpresas &&
            cliente.ClienteEmpresas.some((empresa) =>
                empresa.nombre.toLowerCase().includes(searchTerm)
            );

        // El cliente se incluye si coincide por nombre completo O por el nombre de alguna de sus empresas
        return nombreClienteMatch || nombreEmpresaMatch;
    });

    const [paginaCliente, setPaginaCliente] = useState(1);
    const clientesPorPagina = 5;
    const indexUltimoCliente = paginaCliente * clientesPorPagina;
    const indexPrimeroCliente = indexUltimoCliente - clientesPorPagina;
    const clientesPagina = filteredClientes.slice(indexPrimeroCliente, indexUltimoCliente);
    const totalPaginasCliente = Math.ceil(filteredClientes.length / clientesPorPagina);

    return (
        <Page datos={datos}>
            <Card
                pie={<>
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center w-100 gap-2 mb-3 mb-md-0">
                        <button className="btn btn-success flex-grow-1 flex-md-grow-0" onClick={guardarCotizacion}>
                            Guardar
                            <i className="fas fa-save me-2 mx-2"></i>
                        </button>
                        <h5 className="mb-2 mb-md-0 text-md-end text-center mt-3 mt-md-0">Total de la cotización:
                            <span className="text-success mx-2 fw-bold">{formatoMoneda(totalCotizacion)}
                            </span>
                        </h5>
                    </div>
                </>}>
                <h3 className="text-muted mb-3 text-center text-md-start">{fechaActual}</h3>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">
                    <div className="border rounded p-3 shadow-sm bg-light">
                        <h6 className="text-muted mb-3">Acciones</h6>
                        <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
                            <ModalProductosWizard
                                modalIsOpen={modalIsOpen}
                                setModalIsOpen={setModalIsOpen}
                                listaProductos={listaProductos}
                                agregarAlCarrito={agregarAlCarrito}
                            />
                            <ModalBootstrap
                                titulo="Agregar cliente"
                                nombreBoton="Buscar Cliente"
                                estiloBoton="btn btn-primary me-2 mb-2 mx-1"
                                iconBoton="fa-solid fa-magnifying-glass"
                                modalIsOpen={modalClienteOpen}
                                setModalIsOpen={setModalClienteOpen}
                            >
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar cliente..."
                                        value={clienteSearchTerm}
                                        onChange={(e) => setClienteSearchTerm(e.target.value)}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped table-hover shadow-smr">
                                        <thead className="bg-dark text-white">
                                            <tr>
                                                <th>ID</th>
                                                <th>Empresas</th>
                                                <th>Nombre completo</th>
                                                <th>Agregar</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {clientesPagina.length > 0 ? (
                                                clientesPagina.map((cliente) => (
                                                    <tr key={cliente.id}>
                                                        <td>{cliente.id}</td>
                                                        <td className="align-middle">
                                                            {cliente.ClienteEmpresas && cliente.ClienteEmpresas.length > 0
                                                                ? cliente.ClienteEmpresas.map((empresa, index) => (
                                                                    <div key={index} className="mb-1">
                                                                        {empresa.nombre}
                                                                    </div>
                                                                ))
                                                                : "N/A"}
                                                        </td>
                                                        <td>{cliente.nombreCompleto}</td>
                                                        <td className="text-center align-middle">
                                                            <button
                                                                className="btn btn-success btn-sm"
                                                                onClick={() =>
                                                                    handleClienteSeleccionado(cliente)
                                                                }
                                                            >
                                                                <i className="fa-regular fa-square-check" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center text-muted">
                                                        No se encontraron clientes
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-center">
                                        <nav className="mt-2">
                                            <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                                                {/* Botón "Anterior" */}
                                                <li className={`page-item ${paginaCliente === 1 ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setPaginaCliente(paginaCliente - 1)}
                                                        aria-label="Anterior"
                                                    >
                                                        <i className="fas fa-chevron-left me-1"></i> Anterior
                                                    </button>
                                                </li>

                                                {
                                                    (() => {
                                                        const pagesToShow = 5;
                                                        const halfPages = Math.floor(pagesToShow / 2);
                                                        let startPage = Math.max(1, paginaCliente - halfPages);
                                                        let endPage = Math.min(totalPaginasCliente, paginaCliente + halfPages);

                                                        if (paginaCliente <= halfPages) {
                                                            endPage = Math.min(totalPaginasCliente, pagesToShow);
                                                        }
                                                        if (paginaCliente > totalPaginasCliente - halfPages) {
                                                            startPage = Math.max(1, totalPaginasCliente - pagesToShow + 1);
                                                        }

                                                        const pageButtons = [];
                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <li
                                                                    key={i}
                                                                    className={`page-item ${paginaCliente === i ? "active" : ""}`}
                                                                >
                                                                    <button className="page-link fw-bold" onClick={() => setPaginaCliente(i)}>
                                                                        {i}
                                                                    </button>
                                                                </li>
                                                            );
                                                        }
                                                        return pageButtons;
                                                    })()
                                                }

                                                {/* Botón "Siguiente" */}
                                                <li className={`page-item ${paginaCliente === totalPaginasCliente ? "disabled" : ""}`}>
                                                    <button
                                                        className="page-link"
                                                        onClick={() => setPaginaCliente(paginaCliente + 1)}
                                                        aria-label="Siguiente"
                                                    >
                                                        Siguiente <i className="fas fa-chevron-right ms-1"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </ModalBootstrap>
                            <Link to={"/app/admin/clientes/nuevo"} className="btn btn-primary mb-2 me-2 mx-1"> Nuevo cliente
                                <i className="fas fa-plus mx-2"></i>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="mb-4">
                    {selectedEvent.clienteNombre ? (
                        <div className="alert alert-info d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 p-3">
                            <strong className="me-2">Cliente seleccionado:</strong>
                            <span className="text-break">{selectedEvent.clienteNombre}</span>
                        </div>
                    ) : (
                        <h6 className="text-muted text-center text-md-start">
                            No se ha seleccionado cliente
                        </h6>
                    )}
                </div>
                <div className="mb-3">
                    {carritoCotizacion?.length > 0 ? (
                        <div className="d-flex flex-column gap-3">
                            {carritoCotizacion.map((item, index) => {
                                const uniqueKey = `${item.id}-${item.loteSeleccionado?.id || 'no-lote'}-${item.loteInventarioSeleccionado?.id || 'no-inv'}-${index}`;
                                const subtotal = (parseFloat(item.price) * item.cantidad).toFixed(2);
                                return (
                                    <div key={uniqueKey} className="card shadow-sm p-3 border-secondary">
                                        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                                            <div className="d-flex align-items-center gap-3">
                                                <img
                                                    src={item.imagen || "https://placehold.co/80x80/E0E0E0/333333?text=Sin+Imagen"}
                                                    alt={item.nombre}
                                                    className="img-thumbnail rounded"
                                                    style={{ width: "80px", height: "80px", objectFit: "cover" }}
                                                    onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/80x80/E0E0E0/333333?text=Sin+Imagen" }}
                                                />
                                                <div className="flex-grow-1 mx-2">
                                                    <h5 className="mb-1">{item.nombre}</h5>
                                                    {item.loteSeleccionado && (
                                                        <div className="text-muted small">Lote: {item.loteSeleccionado.nombre_lote}</div>
                                                    )}
                                                    {item.loteInventarioSeleccionado && (
                                                        <div className="text-muted small">Inventario: {item.loteInventarioSeleccionado.inventarioTipo?.nombre}</div>
                                                    )}
                                                    <div className="text-muted small">
                                                        {item.precioAjustadoOriginal && (
                                                            <>
                                                                <span>
                                                                    {formatoMoneda(item.precioAjustadoOriginal)}
                                                                </span>
                                                                <br />
                                                                <span className="text-danger">{formatoMoneda(item.price)}</span>
                                                                <br />
                                                                <span className="badge bg-danger mt-1">Precio ajustado</span>
                                                            </>
                                                        )}
                                                        {item.esMayoreoAplicado ? (
                                                            <>
                                                                <span style={{ textDecoration: 'line-through', color: '#888' }}>
                                                                    {formatoMoneda(item.precioOriginalProducto)}
                                                                </span>
                                                                <br />
                                                                <span className="text-danger">{formatoMoneda(item.price)}</span>
                                                                <br />
                                                                <span className="badge bg-info mt-1">Precio por cantidad aplicado</span>
                                                            </>
                                                        ) : (
                                                            !item.precioAjustadoOriginal && <>{formatoMoneda(item.price)}</>
                                                        )}
                                                        {" "}x {item.cantidad} unidades
                                                    </div>
                                                    <div className="fw-bold text-success mt-1 d-md-none">
                                                        Subtotal: {formatoMoneda(subtotal)}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex flex-grow-1 flex-md-grow-0 align-items-center justify-content-between justify-content-md-end gap-2 mt-2 mt-md-0 w-100 w-md-auto">
                                                <div className="fw-bold text-success d-none d-md-block text-nowrap mx-2">
                                                    Subtotal: {formatoMoneda(subtotal)}
                                                </div>
                                                <div className="d-flex align-items-center gap-1">
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => decrementarCantidad(item.id, item.loteSeleccionado, item.loteInventarioSeleccionado)}
                                                    >
                                                        <i className="fas fa-minus"></i>
                                                    </button>
                                                    <input
                                                        type="number"
                                                        className="form-control text-center mx-2"
                                                        value={item.cantidad}
                                                        onChange={(e) => actualizarCantidad(item.id, e.target.value, item.loteSeleccionado, item.loteInventarioSeleccionado)}
                                                        style={{ width: "85px" }}
                                                    />
                                                    <button
                                                        className="btn btn-outline-primary btn-sm"
                                                        onClick={() => incrementarCantidad(item.id, item.loteSeleccionado, item.loteInventarioSeleccionado)}
                                                    >
                                                        <i className="fas fa-plus"></i>
                                                    </button>
                                                </div>
                                                <button
                                                    className="btn btn-outline-danger btn-sm mx-2"
                                                    onClick={() => setCarritoCotizacion((prev) => prev.filter((p) => !(p.id === item.id && p.loteSeleccionado?.id === item.loteSeleccionado?.id && p.loteInventarioSeleccionado?.id === item.loteInventarioSeleccionado?.id)))}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                                <button
                                                    className="btn btn-outline-warning btn-sm mx-2"
                                                    onClick={() => handleOpenDescuentoModal(item)}
                                                    title="Aplicar descuento o cambiar precio"
                                                >
                                                    <i className="fas fa-percent"></i> Desc.
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <h6 className="text-center">No tienes productos en tu carrito</h6>
                    )}
                </div>
                <div className="form-check form-switch mb-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="switchEnvio"
                        checked={requiereEnvio}
                        onChange={(e) => {
                            setRequiereEnvio(e.target.checked);
                            setMostrarBotonEnvio(e.target.checked);
                        }}
                    />
                    <label className="form-check-label" htmlFor="switchEnvio">
                        ¿Esta cotización requiere envío?
                    </label>
                </div>

                {mostrarBotonEnvio && (
                    <>
                        <div className="row">
                            <div className="col-12">
                                <label className="fw-bold">
                                    <i className="fas fa-truck text-primary me-2"></i>
                                    <span className="mx-2">Costo de envío</span>
                                </label>
                                <p className="text-muted small">
                                    El costo de envío se calculará por separado.
                                </p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <label className="fw-bold">Dirección del envío</label>
                                <div className="pb-3">
                                    <GestionUbicacion
                                        direccion={nuevaDireccion}
                                        setDireccion={setNuevaDireccion}
                                        isModalOpen={isModalOpen}
                                        setIsModalOpen={setIsModalOpen}
                                        setSeleccionarDireccion={setSeleccionarDireccion}
                                        textoBoton={"Agregar Ubicación"}
                                        verdireccion={false}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    {formularioClientes.direcciones
                                        .filter((f) => f.direccion && f.latitud && f.longitud)
                                        .map((f, index) => (
                                            <div key={index} className="row align-items-center mb-2">
                                                <div className="col-9">
                                                    <p className="text-muted mb-0">{f.direccion}</p>
                                                </div>
                                                <div className="col-3 d-flex align-items-center gap-2">
                                                    <VerUbicacion direccion={f} />
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => eliminarDireccion(index)}
                                                        title="Eliminar dirección"
                                                    >
                                                        <i className="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </>
                )}
                <div className="mb-3">
                    <label className="form-label fw-bold">
                        <i className="fas fa-sticky-note me-1"></i> Nota de la cotización:
                    </label>
                    <textarea
                        id="notaGeneral"
                        className="form-control border-primary rounded shadow-sm"
                        placeholder="Agrega una nota general o referencia..."
                        value={notaGeneral}
                        onChange={(e) => setNotaGeneral(e.target.value)}
                    ></textarea>
                </div>
            </Card>
            {selectedItem && (
                <ModalDescuentoCotizacion
                    isOpen={isDescuentoModalOpen}
                    item={selectedItem}
                    onClose={() => setIsDescuentoModalOpen(false)}
                    onApply={handleAplicarDescuento}
                />
            )}
        </Page>
    );
};

export default HomeCotizaciones;